/**
 * `429 + Retry-After` (design/03-auth-and-credentials.md §3.1j's client routing table): `apiClient.ts`
 * waits the server's own `Retry-After` duration before retrying once, and needs a way to tell the rest
 * of the app "a request is in that wait" — otherwise the screen that triggered it just looks hung for
 * however long that is ("a form that looks broken for eight seconds is how a correct control reads as
 * a fault," §3.1e). One process-wide signal, not a per-screen concern — same "no context provider just
 * for this" reasoning as `sessionEvents.ts`, which this mirrors.
 */
let handler: ((waiting: boolean) => void) | undefined

export function registerRateLimitHandler(fn: ((waiting: boolean) => void) | undefined): void {
  handler = fn
}

export function notifyRateLimitWaiting(waiting: boolean): void {
  handler?.(waiting)
}
